import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=03ed8af1&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03ed8af1')) {
      api.createRecord('03ed8af1', component.options)
    } else {
      api.reload('03ed8af1', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=03ed8af1&", function () {
      api.rerender('03ed8af1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2J6W0v6xZznwA/JS/comp/openstreetmap.vue"
export default component.exports